import { useTranslation } from 'react-i18next'
import { TYPE_LABEL_KEYS } from '../TargetingTotalsTable'
import { formatCurrencyAmount } from '@/utils/money'
import type { FloorPrice } from '@/services/lineItems/lineItemDiagnosticsApi'

/**
 * Floor prices one after another, each with what it is limited to: a
 * creative size, or bids that use a kind of targeting. A dash when there are
 * none, so an empty level reads as "no floor" rather than as missing data.
 */
export function FloorPriceList({ floorPrices }: { floorPrices: FloorPrice[] }) {
  const { t } = useTranslation()

  if (floorPrices.length === 0) {
    return <span className="text-(--ad-text-faint)">—</span>
  }

  return (
    <div className="flex flex-col items-end gap-0.5">
      {floorPrices.map((fp, i) => (
        <div key={i} className="text-sm whitespace-nowrap">
          <span className="font-medium tabular-nums">{formatCurrencyAmount(fp.price)}</span>
          {fp.size && (
            <span className="text-(--ad-text-muted)">
              {' · '}
              {fp.size[0]}×{fp.size[1]}
            </span>
          )}
          {fp.targetingType && (
            <span className="text-(--ad-text-muted)">
              {' · '}
              {t(TYPE_LABEL_KEYS[fp.targetingType] ?? fp.targetingType)}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}
